import NoWrapTableCell from 'Components/NoWrapTableCell'
import StyledLink from 'Components/StyledLink'
import StyledTableRow from 'Components/StyledTableRow'
import type { DeviceConfigShape } from 'Services/SalesManagement/Features/WalttiPosRemoteConfig/walttiPosRemoteConfigSlice'
import { SALES_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { showValueOrHyphen } from 'Util/formatters'
import type { FC } from 'react'

const DeviceListRow: FC<{
  row: DeviceConfigShape
}> = ({ row }) => {
  return (
    <StyledTableRow hover>
      <NoWrapTableCell title={row.name} component="th" scope="row">
        <StyledLink
          to={`${SALES_MANAGEMENT_ROOT_URL}/walttipos-remote-config/${row.machine_id}/${row.type_configuration}`}
        >
          {row.name}
        </StyledLink>
      </NoWrapTableCell>
      <NoWrapTableCell title={showValueOrHyphen(row.machine_id)}>
        {showValueOrHyphen(row.machine_id)}
      </NoWrapTableCell>
    </StyledTableRow>
  )
}

export { DeviceListRow }
